import { useEffect, useState } from 'react';
import {
  getSubscriptionRemainingMs,
  formatSubscriptionCountdown,
} from '../utils/subscriptionPlan';

/**
 * Live countdown to subscription end (date + time). Re-renders every second.
 */
export default function useSubscriptionCountdown(endDate, { active = true } = {}) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!active || !endDate) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      setTick((value) => value + 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [active, endDate]);

  const remainingMs = getSubscriptionRemainingMs(endDate);
  const isExpired = remainingMs !== null && remainingMs <= 0;
  const formattedCountdown = formatSubscriptionCountdown(remainingMs);

  return {
    remainingMs,
    isExpired,
    formattedCountdown,
  };
}
